import { FileObject } from '../../../../core/interfaces';

/**
 * The note's saved media followed by the files added on this page that are not saved yet (no id). The note is fetched
 * again after the page opens, and that refresh must not drop a picture pasted before it landed.
 */
export function withUnsavedMedia(saved: FileObject[], current: FileObject[]): FileObject[] {
  return [...(saved ?? []), ...current.filter((file) => !file.id)];
}
